// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_78-3";
export var contentContainer = "_78-0";
export var editorContainer = "_78-1";
export var quillInputForm = "_78-2";
export var zoneDivider = "_78-4";